import { PageHeader } from '@/components/layout/PageHeader';
import { Construction } from 'lucide-react';

export function PlaceholderPage({ title, description }: { title: string; description?: string; icon?: unknown }) {
  return (
    <div className="space-y-6">
      <PageHeader title={title} description={description} />
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <Construction className="h-12 w-12 text-muted-foreground mb-4" />
        <p className="text-lg font-medium text-muted-foreground">Coming soon</p>
        <p className="mt-1 text-sm text-muted-foreground/70">This page is under construction.</p>
      </div>
    </div>
  );
}
